import type { ApexOptions } from 'apexcharts';
import merge from 'deepmerge';
import NumberFormatHelper from '@/ui-kit/helpers/NumberFormatHelper';

export type ApexChart = NonNullable<ApexOptions['chart']>;
export type ApexYAxis = Exclude<NonNullable<ApexOptions['yaxis']>, unknown[]>;
export type Formatter = NonNullable<NonNullable<ApexYAxis['labels']>['formatter']>;
export type BuildCSVExportParams = NonNullable<NonNullable<ApexChart['toolbar']>['export']>['csv'];

export const CURRENCY_FORMATTER: Formatter = (value) => NumberFormatHelper.formatCurrency(value);

export const DEFAULT_OPTIONS: ApexOptions = {
  dataLabels: {
    enabled: false,
  },
  colors: [
    '#009fd4',
    '#0055d4',
  ],
  stroke: {
    width: 2,
  },
  markers: {
    size: 6,
    shape: 'circle',
  },
  xaxis: {
    tooltip: {
      enabled: false,
    },
  },
  tooltip: {
    shared: true,
    intersect: false,
    x: {
      show: true,
    },
  },
  legend: {
    horizontalAlign: 'center',
  },
};

export const buildChart = (chart: ApexChart = {}): ApexOptions => merge({
  chart: {
    width: '100%',
    height: 400,
    type: 'line',
    stacked: false,
  },
}, { chart });

export const buildCSVExport = (csv: BuildCSVExportParams): ApexOptions['chart'] => ({
  toolbar: {
    export: {
      csv: {
        headerCategory: 'Start Date',
        ...csv,
      },
    },
  },
});
